export const visibleValues = {
    // price line based on the closing price
    price: 'close',
    movingAverage50d: 'movingAverage50d',
    movingAverage200d: 'movingAverage200d'
};
